import i18n from "i18n";

const typeMap = {
  ZONE: i18n.t("zone"),
  AREA: i18n.t("sector"),
  SHELF: i18n.t("locations.type.SHELF"),
  LEVEL: i18n.t("locations.type.LEVEL"),
  PLACE: i18n.t("locations.type.PLACE")
};

const typeTitleMap = {
  ZONE: i18n.t("detail.of").concat(' ').concat(i18n.t("zone")),
  AREA: i18n.t("detail.of").concat(' ').concat(i18n.t("sector")),
  SHELF: i18n.t("locations.type.SHELF"),
  LEVEL: i18n.t("locations.type.LEVEL"),
  PLACE: i18n.t("locations.type.PLACE")
};

class Location {
  id = null;
  name = null;
  parent = null;
  type = null;
  measure_height = null;
  measure_width = null;
  measure_depth = null;
  capacity = null;
  dispatch_area = null;

  constructor(obj) {
    // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
    for (var prop in obj) this[prop] = obj[prop];
  }

  getDescriptionPanelView() {
    return [
      {
        title: `${i18n.t("name")} ${i18n.t("of")} ${typeMap[this.type]}`,
        value: this.name
      },
      {
        title: i18n.t("id"),
        value: this.code
      },
      {
        title: `${i18n.t("measure_depth")} (${i18n.t("mts")})`,
        value: `${this.measure_depth / 1000} ${i18n.t("mts")}`
      },
      {
        title: `${i18n.t("measure_height")} (${i18n.t("mts")})`,
        value: `${this.measure_height / 1000} ${i18n.t("mts")}`
      },
      {
        title: `${i18n.t("measure_width")} (${i18n.t("mts")})`,
        value: `${this.measure_width / 1000} ${i18n.t("mts")}`
      },
      {
        title: i18n.t("capacity"),
        value: `${this.capacity == null ? i18n.t("without.informing") : this.capacity + ' ' + i18n.t("products").toLowerCase()}`
      },
      {
        title: i18n.t("ocupation"),
        value: `${this.capacity_busy} ${i18n.t("products").toLowerCase()}`
      }
    ];
  }

  getLocationPanelsView(locations) {
    const areas = locations.filter(location => {
      return location.type === "AREA";
    });

    const shelves = locations.filter(location => {
      return location.type === "SHELF";
    });

    const levels = locations.filter(location => {
      return location.type === "LEVEL";
    });

    const places = locations.filter(location => {
      return location.type === "PLACE";
    });

    if (this.type === "ZONE") {
      return {
        title: i18n.t("sector"),
        subtitle: i18n.t("sector"),
        type: "AREA",
        locations: areas
      };
    }

    if (this.type === "AREA") {
      return {
        title: i18n.t("locations.type.SHELF"),
        subtitle: i18n.t("locations.type.SHELF"),
        type: "SHELF",
        locations: shelves
      };
    }

    if (this.type === "SHELF") {
      return {
        title: i18n.t("locations.type.LEVEL"),
        subtitle: i18n.t("locations.type.LEVEL"),
        type: "LEVEL",
        locations: levels
      };
    }

    if (this.type === "LEVEL") {
      return {
        title: i18n.t("locations.type.PLACE"),
        subtitle: i18n.t("locations.type.PLACE"),
        type: "PLACE",
        locations: places
      };
    }

    return null;
  }

  getAddTitle() {
    return typeTitleMap[this.type];
  }
}
export { Location };
